import React from "react";
import "./App.css";
import { BrowserRouter as Router } from "react-router-dom";
import { CssBaseline } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css";


import "dotenv/config";

import { saveUser } from "./slices/UserSlice";
import { login } from "./slices/TokensSlice";
import LoginPage from "./pages/Login/LoginPage";
import { TOKENS, USER } from "./constants/Constants";
import Theme from "./Theme";

import NavigationRoutes from "./NavigationRoutes";
import { PageMetaProvider } from "./contexts/PageMetaContext";

const App = () => {
  const user = useSelector((state) => state.user.value);
  const tokens = useSelector((state) => state.tokens.value);
  const dispatch = useDispatch();

  let userData = localStorage.getItem(USER);
  if (!user && userData !== "undefined") {
    if (userData) {
      dispatch(saveUser(JSON.parse(userData)));
    }
  }

  let tokensData = localStorage.getItem(TOKENS);
  if (!tokens && tokensData !== "undefined") {
    if (tokensData) {
      dispatch(login(JSON.parse(tokensData)));
    }
  }

  if (!user) {
    return (
      <div>
        <ToastContainer
          position="bottom-right"
          autoClose={4000}
          hideProgressBar
          closeOnClick
          pauseOnHover
          newestOnTop
          style={{ zIndex: 21474840, bottom: "72px" }}
        />
        <LoginPage />
      </div>
    );
  }

  return (
    <ThemeProvider theme={Theme}>
      <CssBaseline />
      <Router>
        <PageMetaProvider>
          <ToastContainer
            position="bottom-right"
            autoClose={4000}
            hideProgressBar
            closeOnClick
            pauseOnHover
            newestOnTop
            style={{ zIndex: 21474840, bottom: "72px" }}
          />
          <NavigationRoutes />
        </PageMetaProvider>
      </Router>
    </ThemeProvider>
  );
};

export default App;
